import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

(() => {
  if (window.__karimProductCardBound) return;
  window.__karimProductCardBound = true;

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.karim-recommended__qty-btn');
    if (!btn) return;

    const qty = btn.closest('.karim-recommended__qty');
    if (!qty) return;

    const valueEl = qty.querySelector('.karim-recommended__qty-value');
    const minusBtn = qty.querySelector('.karim-recommended__qty-btn[name="minus"]');
    const form = qty.closest('.karim-recommended__card-actions')?.querySelector('form');
    const qtyInput = form && form.querySelector('input[name="quantity"]');
    const value = parseInt(valueEl.textContent, 10);

    if (btn.name === 'minus' && value > 1) {
      valueEl.textContent = value - 1;
      if (value - 1 <= 1 && minusBtn) minusBtn.disabled = true;
    } else if (btn.name === 'plus') {
      valueEl.textContent = value + 1;
      if (minusBtn) minusBtn.disabled = false;
    }

    if (qtyInput && valueEl.textContent !== String(value)) {
      qtyInput.value = valueEl.textContent;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('.karim-recommended__card')) return;

    const action = form.getAttribute('action') || form.action;
    if (!action || !action.endsWith('/cart/add')) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    if (button instanceof HTMLButtonElement) button.disabled = true;

    const formData = new FormData(form);
    const variantId = /** @type {string} */ (formData.get('id'));
    const quantity = Number(formData.get('quantity')) || 1;

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        formData.append('sections', item.dataset.sectionId);
      }
    });

    const deferredEventPromise = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity }],
        promise: deferredEventPromise.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      const data = await response.json();

      if (data.status) {
        throw new Error(data.message || 'Add to cart failed');
      }

      const cartResponse = await fetch(`${Theme.routes.cart_url}.json`);
      const cartData = await cartResponse.json();

      deferredEventPromise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartData),
        detail: {
          items: cartData.items,
          source: 'karim-product-card',
          itemCount: cartData.item_count,
          didError: false,
        },
      });

      // Direct fallback to ensure the drawer opens even if the standard event
      // is missed by other handlers.
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) {
        drawer.open();
      }
    } catch (error) {
      console.error('[karim-product-card] Add to cart error:', error);
      document.dispatchEvent(
        new CartErrorEvent({
          error: error instanceof Error ? error.message : 'Add to cart failed',
          code: 'INVALID',
        })
      );
      deferredEventPromise.resolve({
        cart: null,
        detail: { didError: true },
      });
    } finally {
      if (button instanceof HTMLButtonElement) button.disabled = false;
    }
  });
})();
